import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { ENVIRONMENT } from '../../../../environments/environment.interface';
import { Specialization } from '../../../api/app-types/specialization.app';
import { SPECIALIZATION_SERVICE } from '../../../api/services/specialization.service';
import { PaginatedResponse } from '../../pagination/paginated-response';

export const specializationResolver: ResolveFn<PaginatedResponse<Specialization>> = async (
	_route: ActivatedRouteSnapshot,
	_state: RouterStateSnapshot,
) => {
	const api = inject(SPECIALIZATION_SERVICE);
	const env = inject(ENVIRONMENT);
	const response = await api.getAll(undefined, env.pagination.offset, env.pagination.range);
	return response;
};
